export const benefits = [
    {
        title: 'Экономия',
        rows: [
            'Средняя экономия — 17%',
            'В среднем 4 участника на закупку',
            'Анализ НМЦ',
            'Мониторинг цен',
            'Система приглашения участников',
        ],
        icon: 'offer',
    },
    {
        title: 'Простота',
        rows: [
            'Регистрация без лишней бюрократии',
            'Удобный интуитивный интерфейс',
            'Создание закупки за 3 минуты',
        ],
        icon: 'grid',
    },
    {
        title: 'Поддержка',
        rows: [
            '2 личных менеджера по работе на ЭТП',
            'Бесплатная юридическая поддержка',
            'Индивидуальное обучение и семинары',
        ],
        icon: 'message',
    },
    {
        title: 'Индивидуальность',
        rows: [
            'Создание торговых секций закупки',
            'Интеграция с внутренними системами заказчика',
            'Создание дополнительного функционала',
        ],
        icon: 'filter',
    },
    {
        title: 'Эффективность',
        rows: [
            'Гибкая система отчётов',
            'Настраиваемая аналитика',
            'Проверка надёжности поставщика',
        ],
        icon: 'trophy',
    },
];
